import { useQuery } from 'react-query';
import usePlanStore from '../../../../../../store/planStore';
import prepareSelectData from '../utils/prepareSelectData';
import {
  CAMPAIGNS_KEY,
  getSegments,
} from '../../../../../../api/services/mediaPlanning/campaigns';
import { useError } from '../../../common/Errors/ErrorContext/ErrorContext';

const useSegments = (country: string) => {
  const {
    generalInfoState,
    selectedCountryISOCode,
    countryForms,
    selectedCountry,
  } = usePlanStore();

  const { showError } = useError();

  const { data: response, isFetching } = useQuery({
    queryKey: [
      CAMPAIGNS_KEY,
      'segment',
      country,
      countryForms[selectedCountry!]?.campaignScenario,
      countryForms[selectedCountry!]?.targetGroup,
    ],

    queryFn: () =>
      getSegments(
        generalInfoState.division,
        generalInfoState.brand,
        generalInfoState.category
      ),
    enabled:
      !!selectedCountryISOCode &&
      !!generalInfoState.division &&
      !!countryForms[country]?.campaignScenario,
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.message || error.message || 'Unknown error';
      showError(errorMessage);
    },
  });

  const segments = response?.data?.segments || [];
  const preparedData = prepareSelectData(segments);

  return { data: preparedData, isFetching };
};

export default useSegments;
